export default __webpack_public_path__ + "static/media/sidebar-appscentre.9a441032.svg";